import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { style: {"border":"10px solid white"} }, [
  /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"40px","color":"#63acb5","margin-bottom":"5px"} }, " sage串展示 "),
  /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"20px","color":"#63acb5","margin-bottom":"5px"} }, " 看看你做的好事 ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PostNode = _resolveComponent("PostNode")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.res.list, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "plate-class"
        }, [
          _createVNode(_component_PostNode, {
            postNode: item,
            userId: _ctx.userId
          }, {
            "sage-name": _withCtx(() => [
              _createTextVNode(" 支持sage: " + _toDisplayString(item.sageAddUser) + " 反对sage: " + _toDisplayString(item.sageSubUser), 1)
            ]),
            _: 2
          }, 1032, ["postNode", "userId"])
        ]))
      }), 128))
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_el_pagination, {
        layout: "prev, pager, next",
        "page-size": _ctx.pageRes.size,
        "page-count": Math.ceil(_ctx.res.count / _ctx.pageRes.size),
        "hide-on-single-page": Math.ceil(_ctx.res.count / _ctx.pageRes.size) == 1,
        "current-page": _ctx.pageRes.page,
        "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.pageRes.page) = $event))
      }, null, 8, ["page-size", "page-count", "hide-on-single-page", "current-page"])
    ])
  ], 64))
}